import config from 'config.ts';

export const sleep = {
  prevent: function () {
    if (!this._video) {
      this._init();
    }
  },
  allow: function () {
    if (!this._video) {
      return;
    }
  },
  _init: function () {
    const figure = document.createElement("figure");
    figure.innerHTML = `
    <video id="video" preload="metadata" width="1" height="1" autoplay muted loop style="position:absolute ; top:0px; left:0px; z-index:100; width:1px; height:1px;">
    
        <source src={"${config.api.resource}/video-home/vid.mp4"} type="video/mp4" />
    
        <source src={"${config.api.resource}/video-home/vid.webm"} type="video/webm" />
    
        <source src={"${config.api.resource}/video-home/vid.ogv"} type="video/ogg" />
    </video>
    `;

    figure.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement === figure) {
        document.exitFullscreen();
      }
    });

    figure.style.margin = 0;

    document.body.appendChild(figure);
  },
  _video: null,
};
